import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "react-tippy";
import FileCopy from "@material-ui/icons/FileCopy";
import { useIntl } from "react-intl";
import { Paper, IconButton, withStyles } from "@material-ui/core";

import { Tipografia, Flex } from "../../../../_common";

const styles = {
  textoEvento: { display: "flex", flexDirection: "column", height: "100%", width: "100%", padding: "8px 8px 0px 8px" },
  texto: { whiteSpace: "pre-line", paddingBottom: 3 },
  divUrl: {
    height: 16,
    width: "100%",
    "&:hover $rootIconButtons": { display: "block !important" },
  },
  linkLigacao: { color: "#457AB7 !important", marginTop: "auto" },
  smallIcon: {
    width: 18,
    height: 18,
  },
  textoResponsavel: { whiteSpace: "pre-line", paddingBottom: 5 },
  estrelaSmall: {
    fontSize: 21,
  },
  linkJson: {
    margin: "auto 0px 8px auto",
    color: "#3d69a0 !important",
    cursor: "pointer",
  },
  rootIconButtons: {
    display: "none !important",
    width: "32px !important",
    height: "32px !important",
  },
  rootSvgIconButtons: {
    width: "16px !important",
    height: "16px !important",
  },
};

const TimelineItemLogWebHook = ({
  evento,
  handleAbrirModalDetalheLog,
  handleCopiarUrlWebhook,
  isTimelineAtividades,
  classes,
}) => {
  const intl = useIntl();
  return (
    <Paper className={classes.textoEvento} zDepth={1} id="divTimeLine" elevation={isTimelineAtividades ? 0 : 1}>
      <Tipografia className={classes.texto} tipo="notaLegendas" cor="darkSecondaryText">
        {evento.evento}
      </Tipografia>
      <Tipografia className={classes.texto}>{intl.formatMessage({ defaultMessage: "Webhook" })}</Tipografia>
      <Tipografia tipo="notaLegendas" className={classes.texto} cor="darkSecondaryText">
        {evento.tipoAcao}
      </Tipografia>
      <Flex className={classes.divUrl} alignItems="center">
        <Tipografia url={evento.url} urlExterna tipo="notaLegendas" className={classes.texto}>
          {evento.url}
        </Tipografia>
        <div>
          <Tooltip title={intl.formatMessage({ defaultMessage: "Copiar link" })} position="bottom">
            <IconButton
              classes={{ root: classes.rootIconButtons }}
              disableRipple
              onClick={() => handleCopiarUrlWebhook(evento.url)}
            >
              <FileCopy classes={{ root: classes.rootSvgIconButtons }} />
            </IconButton>
          </Tooltip>
        </div>
      </Flex>
      {!isTimelineAtividades && (
        <div className={classes.linkJson} onClick={() => handleAbrirModalDetalheLog(evento)}>
          <Tipografia className={classes.linkJson} tipo="notaLegendas">
            {intl.formatMessage({ defaultMessage: "Ver JSON" })}
          </Tipografia>
        </div>
      )}
    </Paper>
  );
};

TimelineItemLogWebHook.propTypes = {
  evento: PropTypes.object,
  classes: PropTypes.object,
  handleAbrirModalDetalheLog: PropTypes.func,
  handleCopiarUrlWebhook: PropTypes.func,
  isTimelineAtividades: PropTypes.bool,
};

export default withStyles(styles)(TimelineItemLogWebHook);
